import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=43694732&"
import script from "./ListaProdutos.vue?vue&type=script&lang=js&"
export * from "./ListaProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports